"use strict";

// subscribe user to default push keywords topics after login
// needed for APP as they land on mobile web after email link click
// default: End of the World: 13
// default: Breaking news: 8
function subscribeToInitialTopics() {
  document.addEventListener('setLoggedIn', eventData => {
    const userId = eventData.detail.profileData.id;
    const data = {
      'data': [{
        'type': 'user-topic',
        'attributes': {
          'user_id': userId,
          'topic_id': 8
        }
      }, {
        'type': 'user-topic',
        'attributes': {
          'user_id': userId,
          'topic_id': 13
        }
      }]
    };
    const headers = window.baseHeadersJsonApi;
    headers.Authorization = `Bearer ${eventData.detail.token}`;
    fetch(`${window.baseApiUrl}/users/${userId}/topics/many`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    });
  });
}
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/accounts/password/reset/confirm')) {
    const urlParts = window.location.pathname.split('/');
    const token = urlParts.pop();
    const uid = urlParts.pop();
    localStorage.setItem('resetPasswordData', JSON.stringify({
      uid,
      token
    }));
    window.location.href = '/';
  }
  if (window.location.pathname === '/') {
    const resetPasswordData = JSON.parse(localStorage.getItem('resetPasswordData'));
    if (resetPasswordData) {
      const {
        uid,
        token
      } = resetPasswordData;
      window.Unicorn.call('modal-reset-password', 'show', uid, token);
      localStorage.removeItem('resetPasswordData');
    }
  }
});